/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Aoun.Api
 * OpenAPI spec version: 1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  DataTag,
  DefinedInitialDataOptions,
  DefinedUseQueryResult,
  QueryClient,
  QueryFunction,
  QueryKey,
  UndefinedInitialDataOptions,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  GetApiV1StatisticsOverviewParams,
  ProblemDetails,
  StatisticsOverviewDto
} from '.././model';

import { request } from '../../http-client';




export const getApiV1StatisticsOverview = (
    params?: GetApiV1StatisticsOverviewParams,
 signal?: AbortSignal
) => {
      
      
      return request<StatisticsOverviewDto>(
      {url: `/api/v1/statistics/overview`, method: 'GET',
        params, signal
    },
      );
    }
  



export const getGetApiV1StatisticsOverviewQueryKey = (params?: GetApiV1StatisticsOverviewParams,) => {
    return [
    `/api/v1/statistics/overview`, ...(params ? [params]: [])
    ] as const;
    }

    
export const getGetApiV1StatisticsOverviewQueryOptions = <TData = Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError = ProblemDetails>(params?: GetApiV1StatisticsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError, TData>>, }
) => {

const {query: queryOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getGetApiV1StatisticsOverviewQueryKey(params);

  

    const queryFn: QueryFunction<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>> = ({ signal }) => getApiV1StatisticsOverview(params, signal);

      

      

   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError, TData> & { queryKey: DataTag<QueryKey, TData, TError> }
}

export type GetApiV1StatisticsOverviewQueryResult = NonNullable<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>>
export type GetApiV1StatisticsOverviewQueryError = ProblemDetails


export function useGetApiV1StatisticsOverview<TData = Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError = ProblemDetails>(
 params: undefined |  GetApiV1StatisticsOverviewParams, options: { query:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError, TData>> & Pick<
        DefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1StatisticsOverview>>,
          TError,
          Awaited<ReturnType<typeof getApiV1StatisticsOverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  DefinedUseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1StatisticsOverview<TData = Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError = ProblemDetails>(
 params?: GetApiV1StatisticsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError, TData>> & Pick<
        UndefinedInitialDataOptions<
          Awaited<ReturnType<typeof getApiV1StatisticsOverview>>,
          TError,
          Awaited<ReturnType<typeof getApiV1StatisticsOverview>>
        > , 'initialData'
      >, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }
export function useGetApiV1StatisticsOverview<TData = Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError = ProblemDetails>(
 params?: GetApiV1StatisticsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError, TData>>, }
 , queryClient?: QueryClient
  ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> }

export function useGetApiV1StatisticsOverview<TData = Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError = ProblemDetails>(
 params?: GetApiV1StatisticsOverviewParams, options?: { query?:Partial<UseQueryOptions<Awaited<ReturnType<typeof getApiV1StatisticsOverview>>, TError, TData>>, }
 , queryClient?: QueryClient 
 ):  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> } {

  const queryOptions = getGetApiV1StatisticsOverviewQueryOptions(params,options)

  const query = useQuery(queryOptions, queryClient) as  UseQueryResult<TData, TError> & { queryKey: DataTag<QueryKey, TData, TError> };

  query.queryKey = queryOptions.queryKey ;

  return query;
}




